export enum TasksStatus {
    OPEN    = 'open',
    CLOSED  = 'closed',
    ALL     = 'all',
}

export const TasksStatusLabel = {
    [TasksStatus.OPEN]  : 'Open tasks',
    [TasksStatus.CLOSED]: 'Closed tasks',
    [TasksStatus.ALL]   : 'All tasks',
}